// extracted by mini-css-extract-plugin
export default {"container":"OptionSwitch_container__ir6Qw","option":"OptionSwitch_option__pfV4G","indicator":"OptionSwitch_indicator__j89pH","right":"OptionSwitch_right__xUP0O"};